import { create } from 'zustand'

type PaymentStatus =
  | 'idle'
  | 'loading'
  | 'awaiting'
  | 'confirming'
  | 'paid'
  | 'expired'
  | 'error'

interface PaymentStoreState {
  clientSecret: string | null
  paymentIntentId: string | null
  deadline: string | null
  status: PaymentStatus
  error: string | null
  setClientSecret: (secret: string | null) => void
  setDeadline: (deadline: string | null) => void
  setStatus: (status: PaymentStatus) => void
  setError: (error: string | null) => void
  clear: () => void
}

export const usePaymentStore = create<PaymentStoreState>(set => ({
  clientSecret: null,
  paymentIntentId: null,
  deadline: null,
  status: 'idle',
  error: null,
  setClientSecret: secret => set({ clientSecret: secret }),
  setDeadline: deadline => set({ deadline }),
  setStatus: status => set({ status }),
  setError: error => set({ error }),
  clear: () =>
    set({
      clientSecret: null,
      paymentIntentId: null,
      deadline: null,
      status: 'idle',
      error: null
    })
}))
